import invariant from "tiny-invariant"

export const getMetaContentMaybe = <T = string>(
  name: string,
  { json = false }: { json?: boolean } = {}
): T | null => {
  const metaTag = document.querySelector(`meta[name=${name}]`)
  const content = metaTag?.getAttribute("content") ?? null
  return (json && content ? JSON.parse(content) : content) as T | null
}

export const getMetaContent = <T>(name: string, { json = false }: { json?: boolean } = {}): T => {
  const content = getMetaContentMaybe<T>(name, { json })
  invariant(content)

  return content
}
